import { render, staticRenderFns } from "./BooleanParameter.vue?vue&type=template&id=4973d577&"
import script from "./BooleanParameter.vue?vue&type=script&lang=ts&"
export * from "./BooleanParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports